import { isOpenableUrl } from '@littlebird/ui-utils';
import { toast } from 'sonner';

import { handleExternalUrlClick } from '@/utils/platform';

import { Button } from '../ui/Button';
import { Dialog } from '../ui/dialog';

import { type ModalFC } from './modalsManager';

interface ExternalLinkModalProps {
  url: string;
}

export const ExternalLinkModal: ModalFC<ExternalLinkModalProps> = ({
  open,
  onOpenChange,
  url,
}) => {
  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Link copied');
      onOpenChange(false);
    } catch {
      toast.error('Failed to copy link');
    }
  };

  const handleOpenLink = () => {
    if (!isOpenableUrl(url)) {
      toast.error('Invalid link');
      return;
    }
    handleExternalUrlClick(url);
    onOpenChange(false);
  };

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content className="max-w-lg">
        <Dialog.Header>
          <Dialog.Title>Verify this link</Dialog.Title>
          <Dialog.Description>
            This link goes to a third-party site. Review the URL and only
            proceed if you trust the destination.
          </Dialog.Description>
        </Dialog.Header>

        <div className="text-sm text-foreground-muted break-all">{url}</div>

        <Dialog.Footer className="mt-4 gap-1">
          <Button size="sm" variant="outline" onClick={handleCopyLink}>
            Copy link
          </Button>
          <Button size="sm" onClick={handleOpenLink}>
            Open link
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
